
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ipage/[pagePath]",
      function () {
        return require("private-next-pages/ipage/[pagePath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ipage/[pagePath]"])
      });
    }
  